import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { format } from 'date-fns'
import { selectDropdownOptions, selectDropdowns } from "../redux/dropdownSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { setChangeMade } from '../redux/paymentSchedulePanelSlice'

export default function PaymentDatePicker(props) {
  let { paymentMethodDdoId, min, max, selectedDate, setSelectedDate, defaultToMax = false, isDisabled = false } = props
  const dropdownOptions = useSelector(selectDropdownOptions);
  const dropdowns = useSelector(selectDropdowns);
  const paymentMethodDdo = dropdownOptions.filter((o) => o.id === paymentMethodDdoId)[0]
  const holidayDropdown = dropdowns.data.filter((o) => o.code_key === 'holiday')[0]
  const holidays = dropdownOptions.filter((o) => o.dropdown_id === holidayDropdown.id).map((o) => o.optional_value_1)
  //Only filter date when the payment method is digital payment and not debit card
  const isFilterDate = ['payment_method_ach'].includes(paymentMethodDdo?.code_key)
  const dispatch = useDispatch()

  useEffect(() => {
    if (isFilterDate && selectedDate && !filterDate(selectedDate)) {
      setSelectedDate(defaultToMax ? max : null);
    }
  }, [paymentMethodDdoId])

  const filterDate = (date) => {
    const day = date?.getDay()
    return day !== 0 && day !== 6 && !isHoliday(date)
  }
  const isHoliday = (date) => {
    return holidays?.some((holiday) => format(new Date(holiday), 'MM/dd/yy') === format(date, 'MM/dd/yy'));
  }

  return (
    <DatePicker
      showIcon
      selected={selectedDate ? selectedDate : new Date(`${min}`)}
      onChange={(date) => {
        setSelectedDate(date)
        dispatch(setChangeMade(true))
      }}
      filterDate={isFilterDate ? filterDate : null}
      maxDate={max}
      icon={<FontAwesomeIcon icon={faCalendar} className={'is-size-6 pr-1'} />}
      minDate={min ? min : new Date()}
      placeholderText={'mm/dd/yyyy'}
      disabled={isDisabled || !paymentMethodDdoId}
      includeMaxDate
    />
  );
}
